// Moment
import moment from 'moment';

/**
 * @description Format to desired date
 *
 * @param {string} date
 * @param {object} options
 *
 * @return {string} string
 */
export const dateUtils_formatDate = (
  date: string,
  options?: {
    tableFormat?: boolean;
    withoutTime?: boolean;
    withDay?: boolean;
    now?: boolean;
    IsScheduling?: boolean;
    IsBirthDate?: boolean;
    IsComment?: boolean;
    withHours?: boolean;
  },
) => {
  // Check if date is null
  if (date === '' || !date) return '-';

  const convertDate = options?.IsScheduling ? moment(date) : moment(date).add(7, 'hours');

  const format =
    options?.tableFormat && options?.IsBirthDate
      ? 'LL'
      : options?.tableFormat && options?.IsComment
      ? 'dddd, DD MMM YYYY'
      : options?.tableFormat && !options?.withoutTime
      ? 'DD/MM/YYYY - HH:mm:ss'
      : options?.tableFormat && options?.withoutTime
      ? 'DD/MM/YYYY'
      : options?.withDay
      ? 'dddd, DD MMM YYYY, HH:mm'
      : options?.withHours
      ? 'HH:mm'
      : 'DD MMMM YYYY';

  if (options?.now && moment() <= convertDate.add(5, 'minutes')) {
    return `Baru Saja`;
  } else if (options?.now && moment() <= convertDate.add(1, 'hours')) {
    return moment(date).add(7, 'hours').startOf('minute').fromNow();
  } else if (options?.now && moment() <= convertDate.add(1, 'days')) {
    return moment(date).add(7, 'hours').startOf('hour').fromNow();
  } else {
    return options?.IsScheduling ? moment.utc(date).format(format) : moment.utc(date).add(7, 'hours').format(format);
  }
};

// if (options?.now && (moment().add(1, 'hours').milliseconds() - convertDate.milliseconds()) >= 0) {
//   if (options?.now && (moment().add(1, 'days').milliseconds() - convertDate.milliseconds()) >= 0) {
//     return convertDate.startOf('hour').fromNow();
//   } else {
//     return convertDate.startOf('minutes').fromNow();
//   }
// } else {
//   return `Baru Saja`;
// }
